import ApiClient from "@/api/ApiClient.ts";
// import qs from "qs";

const state = {
  tripsToPreview: [],
  filtersFormGetInvoice: {
    centralAndWorkgroup: {
      wgId: "",
    },
    subscribers: [0],
    invoicingFrom: "",
    invoicingTo: "",
  },
  tripsToPreviewWithFilters: [],
  tripsToPreviewDataRecycler: {},
  dataToCache: null,
};

const mutations = {
  setTripsToPreview(state, trips) {
    state.tripsToPreview = trips;
  },

  setFiltersFormGetInvoice(state, filters) {
    state.filtersFormGetInvoice = filters;
  },

  setTripsToPreviewWithFilters(state, trips) {
    state.tripsToPreviewWithFilters = trips;
  },

  setTripsToPreviewDataRecycler(state, data) {
    state.tripsToPreviewDataRecycler = data;
  },

  setDataToCache(state, data) {
    state.dataToCache = data;
  },
};

const actions = {
  async getTripsBilling({ commit }, payload) {
    const params = {
      ...payload.params,
    };

    try {
      const api = ApiClient();
      let response = await api.get("/trips/billing", {
        params,
        responseType: payload.params.output === "xlsx" ? "blob" : undefined,
      });
      if (payload.params.output === "xlsx") {
        return response.data;
      } else {
        commit("setTripsToPreview", response.data);
      }
    } catch (error) {
      console.error("ERROR en getTripsBilling: ", error.response);
      return error.response.status;
    }
  },
};

const getters = {
  tripsToPreview(state) {
    if (state.tripsToPreview) {
      return state.tripsToPreview;
    }
  },

  filtersFormGetInvoice(state) {
    if (state.filtersFormGetInvoice) {
      return state.filtersFormGetInvoice;
    }
  },

  tripsToPreviewWithFilters(state) {
    if (state.tripsToPreviewWithFilters) {
      return state.tripsToPreviewWithFilters;
    }
  },

  tripsToPreviewDataRecycler(state) {
    return state.tripsToPreviewDataRecycler;
  },

  dataToCache(state) {
    if (state.dataToCache) {
      return state.dataToCache;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
